import { useMemo } from "react";
import { formatDate } from "apps/project-iq/utils/workspaceOverviewUtils";
import { NO_VALUE_PLACEHOLDER } from "./TeamReviewTracker.constants";
import { ReviewStatusCard } from "./ReviewStatusCard";
import { useReviewStatusDashboardStyles } from "./ReviewStatusDashboard.styles";
import { IReviewStatusDashboardProps } from "./ReviewStatusDashboard.types";

const MILLISECONDS_PER_DAY = 86_400_000;

export const ReviewStatusDashboard = ({
  rows,
  projectEndDate,
}: IReviewStatusDashboardProps): JSX.Element => {
  const styles = useReviewStatusDashboardStyles();

  const completedCount = useMemo(
    () => rows.filter((row) => row.status === "complete").length,
    [rows],
  );
  const pendingCount = useMemo(
    () => rows.filter((row) => row.status === "pending").length,
    [rows],
  );

  const formattedEndDate = useMemo(
    () => (projectEndDate ? formatDate(projectEndDate) : NO_VALUE_PLACEHOLDER),
    [projectEndDate],
  );

  const daysRemaining = useMemo<string | number>(() => {
    if (!projectEndDate) return NO_VALUE_PLACEHOLDER;
    const endTime = new Date(`${projectEndDate}T00:00:00`).getTime();
    if (Number.isNaN(endTime)) return NO_VALUE_PLACEHOLDER;
    return Math.max(
      0,
      Math.ceil((endTime - Date.now()) / MILLISECONDS_PER_DAY),
    );
  }, [projectEndDate]);

  return (
    <div className={styles.grid}>
      <ReviewStatusCard label="Team Members" value={rows.length} />
      <ReviewStatusCard label="Reviews Completed" value={completedCount} />
      <ReviewStatusCard label="Reviews Pending" value={pendingCount} />
      <ReviewStatusCard label="Project End Date" value={formattedEndDate} />
      <ReviewStatusCard
        label="Days Remaining Until Closeout"
        value={daysRemaining}
      />
    </div>
  );
};
